export default __webpack_public_path__ + "static/media/career-categories.928b2998.png";